import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "wo-organization-list"
};
const _hoisted_2 = {
  class: "org-leadership"
};
const _hoisted_3 = {
  class: "org-desc"
};
const _hoisted_4 = {
  class: "org-oddment"
};
import { computed, onMounted, ref } from "vue";
import store from "@/store";
import { request } from "@/manager/net_manager";
import { calculateMD5, compressImage, isAdminType } from '@/tools/utils';
import { ElMessage } from 'element-plus'; // refs

export default {
  __name: 'WOOrganizationList',

  setup(__props) {
    const message = ref(null);
    const file = ref(null);
    const md5Value = ref(null);
    const imageInput = ref(null);
    const organizationId = ref(null);
    const dataArray = ref(null); // computed

    const userType = computed(() => {
      return store.state.user ? parseInt(store.state.user.user_type) : 4;
    });
    const worldOutlook = computed(() => store.state.world_outlook); // functions

    const getData = () => {
      if (worldOutlook.value) {
        const parameters = {
          'world_outlook_id': worldOutlook.value.id
        };
        request('wo_organizations/organizations/get/', parameters, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            dataArray.value = response.data;
          }
        });
      }
    };

    const clickImage = itemId => {
      if (!isAdminType(userType.value)) return;
      organizationId.value = itemId;
      imageInput.value.click();
    };

    const handleInputChange = event => {
      file.value = event.target.files[0];

      if (file.value) {
        compressImage(file.value, 2 * 1024 * 1024, value => {
          file.value = value;
          calculateMD5(file.value, value => {
            // console.log(`md5 = ${value}`)
            md5Value.value = value;
            uploadImage();
          });
        });
      }
    };

    const uploadImage = async () => {
      if (message.value) {
        message.value.close();
      }

      const formData = new FormData();
      formData.append('file', file.value);
      formData.set('name', file.value.name);
      formData.set('path', 'wo_organization_emblem');
      formData.set('md5', md5Value.value);
      formData.set('organization_id', organizationId.value);
      const headers = {
        'Content-Type': 'multipart/form-data'
      };
      const response = await request('wo_organizations/organization/emblem/upload/', formData, 'UPLOAD', headers); // console.log(`upload_market_props_image ${JSON.stringify(response)}`)

      if (response.code !== 0) {
        message.value = ElMessage.error(response.msg);
        return;
      }

      message.value = ElMessage.success('上传成功');
      organizationId.value = null;
      file.value = null;
      md5Value.value = null;
      imageInput.value.value = null;
      getData();
    }; // lifecycle


    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");

      return dataArray.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_unref(isAdminType)(userType.value) ? (_openBlock(), _createElementBlock("input", {
        key: 0,
        type: "file",
        accept: "image/png, image/jpeg",
        style: {
          "display": "none"
        },
        ref_key: "imageInput",
        ref: imageInput,
        onChange: handleInputChange
      }, null, 544)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataArray.value, item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "wo-organization-item"
        }, [item.is_top ? (_openBlock(), _createBlock(_component_el_image, {
          key: 0,
          class: "org-emblem",
          src: item.emblem,
          draggable: "false",
          onClick: $event => clickImage(item.id)
        }, null, 8, ["src", "onClick"])) : _createCommentVNode("", true), _createElementVNode("text", {
          class: _normalizeClass(["org-name", item.is_top ? 'is-top' : ''])
        }, [_createElementVNode("b", null, _toDisplayString(item['name']), 1), _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)), _createElementVNode("span", _hoisted_2, _toDisplayString(item.leadership && item.leadership.length > 0 ? `${item['leadership']}` : ''), 1)], 2), _cache[3] || (_cache[3] = _createElementVNode("div", {
          class: "divider"
        }, null, -1)), _createElementVNode("div", _hoisted_3, [_createTextVNode("         " + _toDisplayString(item['desc']), 1), _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1))]), _createElementVNode("div", _hoisted_4, [_createTextVNode("         " + _toDisplayString(item['oddment']), 1), _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1))])]);
      }), 128))])) : _createCommentVNode("", true);
    };
  }

};